export const downloadFile = async (presignedUrl: string, fileName: string) => {
  const link = document.createElement('a');
  link.href = presignedUrl;
  link.download = fileName;
  link.target = '_blank';
  link.click();
};
